import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { sessionReducer, SessionEffects } from './features/session/store';
import { presentationsReducer } from './features/library/store';
import * as PresentationsEffects from './features/library/store/presentations.effects';
import { sessionsListReducer, SessionsListEffects } from './features/sessions-list/store';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore(),
    provideState('session', sessionReducer),
    provideState('presentations', presentationsReducer),
    provideState('sessionsList', sessionsListReducer),
    provideEffects(SessionEffects, PresentationsEffects, SessionsListEffects),
    ...(isDevMode() ? [provideStoreDevtools({ maxAge: 25 })] : []), provideAnimationsAsync(),
  ],
};
